module.exports = __webpack_public_path__ + "img/icon_1_25.8b80d8d0.png";